import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  container: {
    maxWidth: '720px',
    padding: theme.spacing(2),
  },

  closedWonQueueLink: {
    marginTop: theme.spacing(2),
  },

  divider: {
    height: 0,
    borderTop: '1.5px dashed #979797',
    boxSizing: 'border-box',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
  },

  viewButton: {
    color: theme.palette.text.primary,
    fontSize: '12px',
  },
})
